import React from "react";
import { Tooltip, TooltipProps, styled } from "@mui/material";

interface StyledTooltipProps extends TooltipProps {
  type: "dark" | "light";
}

const ToBeStyledTooltip = ({ className, ...props }: StyledTooltipProps) => (
  <Tooltip {...props} classes={{ tooltip: className }} />
);

export const StyledTooltip = styled(ToBeStyledTooltip, {
  shouldForwardProp: (propName) => propName !== "type",
})(({ theme, type }) => ({
  backgroundColor: theme.wsc.palette.neutral[type === "dark" ? 800 : 100],
  color: theme.wsc.palette.neutral[type === "dark" ? 100 : 700],
  border: `0.071rem solid ${theme.wsc.palette.neutral[500]}`,
  fontSize: theme.wsc.typography.body2.fontSize,
  fontWeight: theme.wsc.typography.body2.fontWeight,
  padding: theme.wsc.spacing[1],
  borderRadius: theme.wsc.radius.m,
  boxShadow: theme.wsc.shadow.s1,
}));
